import PropTypes from "prop-types";

import { labelRowCss, editingAreaCss } from "./AnnotationTextArea.style";

const propTypes = {
  handleOnChange: PropTypes.func,
  rows: PropTypes.number,
  isReply: PropTypes.bool,
  isCommentEditMode: PropTypes.bool,
  text: PropTypes.string,
  noCommentError: PropTypes.bool,
  annotationTextAreaRef: PropTypes.shape({
    current: PropTypes.object,
  }),
};

const AnnotationTextArea = ({
  annotationTextAreaRef,
  isCommentEditMode,
  isReply,
  handleOnChange,
  noCommentError,
  rows = 3,
  text,
}) => {
  const getFormLabelText = () =>
    isReply ? (
      "Reply"
    ) : (
      <>
        Annotation <span>(optional)</span>
      </>
    );

  return (
    <>
      {isCommentEditMode ? null : (
        <label htmlFor="annotationInput" css={labelRowCss(isReply)}>
          {getFormLabelText()}
        </label>
      )}
      <textarea
        id="annotationInput"
        aria-describedby={noCommentError ? "noCommentError" : null}
        placeholder="Start typing..."
        rows={rows}
        name="annotation-text"
        css={editingAreaCss(noCommentError, isCommentEditMode)}
        value={text}
        onChange={handleOnChange}
        ref={annotationTextAreaRef}
      />
    </>
  );
};

AnnotationTextArea.propTypes = propTypes;
export default AnnotationTextArea;
